// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyProps } from "@insite/mobius/Typography";
import { pointDataStyles } from "@stoneage/App/Components/ProductDetails/PointData";
import { color, ellipsis } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";
import { fontConfig } from "@stoneage/XDL/constants";

pointDataStyles.imageAndDescription = {
    css: css`
        display: flex;
        gap: 16px;
    `,
};

pointDataStyles.productDescription = {
    productDetailLink: {
        typographyProps: {
            ...fontConfig.regularSingleLine,
            weight: fontConfig.weight.bold,
            css: css`
                ${ellipsis(3)};
            `,
        },
    },
    productDetailDescription: {
        ...fontConfig.regularSingleLine,
        weight: fontConfig.weight.bold,
        css: css`
            ${ellipsis(3)};
        `,
    },
};

pointDataStyles.description = {
    ...fontConfig.regularSingleLine,
    weight: fontConfig.weight.bold,
    css: css`
        ${ellipsis(3)};
    `,
};

pointDataStyles.buttonWrapper = {
    css: css`
        margin-top: 12px;
        .contact-for-quote-msg {
            display: none;
        }
    `,
};

pointDataStyles.button = {
    sizeVariant: "small",
    css: css`
        width: 100%;
        justify-content: center;
    `,
};

pointDataStyles.leftPart = {
    css: css`
        width: 80px;
        height: 80px;
    `,
};

pointDataStyles.image = {
    css: css`
        width: 80px;
        height: 80px;
        img {
            width: 100%;
            height: auto;
            border: 1px solid ${color("common.ui5")};
        }
    `,
};

pointDataStyles.productPartNumbers = {
    erpNumberLabelText: {
        ...fontConfig.xSmallSingleLine,
        color: "text.main",
    },
    erpNumberValueText: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.medium,
        color: "text.main",
    },
    customerNameLabelText: {
        ...fontConfig.xSmallSingleLine,
        color: "text.main",
    },
    customerNameValueText: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.medium,
        color: "text.main",
    },
    serialNumberLabelText: {
        ...fontConfig.xSmallSingleLine,
        color: "text.main",
    },
    serialNumberValueText: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.medium,
        color: "text.main",
    },
    manufacturerItemLabelText: {
        ...fontConfig.xSmallSingleLine,
        color: "text.main",
    },
    manufacturerItemValueText: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.medium,
        color: "text.main",
    },
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            row-gap: 4px;
            .item-cont {
                display: flex;
            }
        `,
    },
};

pointDataStyles.priceSavingExtendedStyles = {
    wrapper: {
        css: css`
            display: flex;
            gap: 8px;
            white-space: nowrap;
            align-items: baseline;
        `,
    },
    messageWrapper: {
        css: css`
            display: flex;
            gap: 4px;
            align-items: baseline;
        `,
    },
    label: {
        ...fontConfig.xSmallSingleLine,
        color: "text.main",
    },
    price: {
        ...fontConfig.xSmallSingleLine,
        color: "text.main",
        weight: fontConfig.weight.medium,
    },
    discount: {
        ...fontConfig.xSmallSingleLine,
        color: "text.main",
    },
};

pointDataStyles.price = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
        `,
    },
    price: {
        priceText: {
            variant: "h4",
        },
    },
};

const sharedTextStyles: TypographyProps = {
    variant: "p",
    size: 12,
    color: "text",
    css: css`
        letter-spacing: 0;
        line-height: 18px;
        margin-bottom: 0;
        text-transform: none;
    `,
};

pointDataStyles.partNumber = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            width: auto;
        `,
    },
    heading: {
        ...sharedTextStyles,
        css: css`
            ${sharedTextStyles.css}
            display: flex;
            &:after {
                content: ":";
                margin-right: 4px;
            }
        `,
    },
    text: {
        ...sharedTextStyles,
        css: css`
            ${sharedTextStyles.css}
            ${wrapInContainerStyles}
            width: auto;
            font-weight: bold;
            color: ${color("common.black")};
        `,
    },
};

pointDataStyles.priceAndInventoryWrapper = {
    css: css`
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    `,
};

pointDataStyles.rightPart = {
    css: css`
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

pointDataStyles.availabilityStyles = {
    messageGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    availabilityByWarehouseLinkGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
};

pointDataStyles.priceTextStyle = {
    css: css`
        line-height: 24px;
        font-size: 20px;
        font-weight: bold;
        margin-top: 18px;
    `,
};
